<template>
    <div
        class="g table"
    >
        <gSearch
            v-if="(haveSearch || download) && content.length"

            :title="titleComputed"
            :content="content"
            :setTitle="setTitle"
            :download="download"
            :ctrlSearchCondition="ctrlSearchCondition"
            :realSearchInfoExport="realSearchInfoExport"
            :ctrlDisplayToolBar="ctrlDisplayToolBar"
            :searchBtnList="searchBtnList"

            @sendEvent="receiveEvent"
        >
           
        </gSearch>
        <slot name="top"></slot>
        <mdMajorTable
            v-if="pageFilter && pageFilter.length"
            ref="mdMajorTable"

            :title="titleComputed"
            :content="pageFilter"
            :fixedHeader="fixedHeader"
            :click="click"
            :drop="drop"
            :check="check"
            :checkMultiple="checkMultiple"
            :focus="focus"
            :sortable="sortable"
            :haveBorder="haveBorder"
            :away="away"
            :catchNodeSn="catchNodeSn"
            :dropString="dropString"

            @sendEvent="receiveEvent"
        ></mdMajorTable>
        <div
            v-else
            class="md"
        >
            <cpStatus
                tag="div"
                themes="major"
                icon="warning"
                :text="$t('page.orderhistory.status.noresults')"
            ></cpStatus>
        </div>
        <slot name="bottom"></slot>
        <mdPageination
            v-if="showFilter && showFilter.length && havePageination"
            :page="targetPage"
            :selector="selector"
            :setLength="show"
            :length="length"

            @sendEvent="receiveEvent"
        ></mdPageination>
    </div>
</template>

<script>
    import mdMajorTable from '@/components/mdMajorTable'
    import gSearch from '@/components/gSearch'
    import mdPageination from '@/components/mdPageination'
    import cpStatus from '@/components/cpStatus'
    

    import { mapMutations } from 'vuex'

    export default {
        components: {
            mdMajorTable,
            gSearch,
            mdPageination,
            cpStatus,
        },
        props: {
            haveSearch: {
                type: Boolean,
                require: false,
                default: true
            },
            table: {
                type: Object,
                require: true,
                default: function(){
                    return {}
                }
            },
            setTitle: { //是否讓使用者自選要顯示的欄位
                type: Boolean,
                require: false,
                default: false
            },
            download: { //是否讓使用者下載
                type: Boolean,
                require: false,
                default: false
            },
            downloadName: {
                type: String,
                require: false,
                default: ''
            },
            displayToolBar: { //預設顯示工具列
                type: Boolean,
                require: false,
                default: true
            },
            fixedHeader: { //固定 title 再螢幕上方
                type: Boolean,
                require: false,
                default: true
            },
            click: { //開啟 click 功能
                type: Boolean,
                require: false,
                default: false
            },
            drop: { //開啟 drop 功能
                type: Boolean,
                require: false,
                default: false
            },
            check: { //開啟 check 的功能，並要用什麼屬性接 true false
                type: String,
                require: false,
                default: ''
            },
            checkMultiple: { //check 是否可開啟多選功能
                type: Boolean,
                require: false,
                default: true
            },
            focus: { //開啟 focus 功能
                type: Boolean,
                require: false,
                default: false
            },
            sortable: { //是否可以排序
                type: Boolean,
                require: false,
                default: true
            },
            haveBorder: {
                type: Boolean,
                require: false,
                default: false
            },
            havePageination: { //是否顯示底部分頁
                type: Boolean,
                require: false,
                default: true
            },
            pageSet: { //設定分頁
                type: Number,
                require: false,
                default: 1
            },
            pageFunc: {
                type: Function,
                require: false,
            },
            setLength: { //調整 table 一頁的列數
                type: Number,
                require: false,
                default: 10
            },
            selector: { //調整 table 可切換的單頁筆數
                type: Array,
                required: false,
                default: function(){
                    return [10, 20, 50, 100, 200, 500]
                }
            },
            rememberHistory: { //是否要開啟記錄功能
                type: Boolean,
                require: false,
                default: true
            },
            dropString: { //'拖曳' 欄位的標題
                type: String,
                require: false,
            },
            searchBtnList: { //擴增按鈕功能
                type: Array,
                required: false
            }
        },
        data: function(){
            let _setLength = this.setLength || 10,
                _displayToolBar = this.displayToolBar;

            let _page = this.pageSet;

            return {
                show: _setLength,
                page: _page,
                searchInit: false, //第一次 search 自動觸發，不強制回到第一頁
                moveNode: null, //開始拖曳的物件為何
                away: '', //拖曳的方向
                catchNodeSn: '',
                ctrlSearchCondition: {}, //介面上的搜尋
                realSearchCondition: {}, //實際上正在用的搜尋
                ctrlDisplayToolBar: _displayToolBar
            }
        },
        computed: {
            maxPage: function(){
                let _show = this.show,
                    _max = Math.ceil(this.length / _show);

                return _max;
            },
            targetPage: function(){
                let _maxPage = this.maxPage,
                    _page = this.page;

                if( _page < 1 ) {
                    _page = 1;
                }
                
                return Math.min(_page, _maxPage); //如果大於最大頁面，就用最大頁面
            },
            titleIDname: function(){
                let _name = '',
                    $table = this.table || {},
                    $title = $table.title || [];

                $title.forEach(title => {
                    _name = _name +'-'+ title.prop;
                });

                _name = _name.replace(/^\-/, '');

                return _name;
            },
            title: function(){
                let $table = this.table,
                    $title = $table.title || [];

                return $title;
            },
            content: function(){
                let $table = this.table,
                    $content = $table.content || [];

                return $content;
            },
            titleComputed: function(){
                let $title = this.title,
                    $filter = $title.filter(item => item.visible);

                $filter.sort((a, b) => {

                    if( a.sortnum > b.sortnum ) {
                        return 1;
                    }else if( a.sortnum < b.sortnum ) {
                        return -1;
                    }
                });

                return $filter;
            },
            showFilter: function(){
                let $content = this.content || [],
                    $show = $content.filter(data => data.show === true);

                $show.forEach((data, _index) => { //init
                    data.page = Math.floor(_index / this.show) + 1;
                });

                return $show;
            },
            pageFilter: function(){

                if( this.havePageination ) {
                    return this.showFilter.filter(data => data.page === this.targetPage);
                }else {
                    return this.showFilter;
                }
            },
            length: function(){
                return this.showFilter.length;
            },
            computedRealSearchCondition: function(){
                return this.searchConditionCompute(this.realSearchCondition);
            },
            computedSearchCondition: function(){
                return this.searchConditionCompute(this.ctrlSearchCondition);
            },
            realSearchInfoExport: function(){
                let $computedSearchCondition = this.computedRealSearchCondition || {},
                    $result = [];

                for( let _key in $computedSearchCondition ) {
                    let $condition = $computedSearchCondition[_key],
                        value = $condition.value,
                        _caption = $condition.caption;

                    let _value = '';

                    if( typeof value === 'boolean' ) {

                        if( value ) {
                            _value = '是';
                        }else {
                            _value = '否';
                        }
                    }else if( typeof value === 'string' ) {
                        _value = value;
                    }else if( Array.isArray(value) ) {
                        _value = value.join(', ');
                    }else if( typeof value === 'object' ) {
                        let $value = [];

                        for( let __key in value ) {

                            if( value[__key] ) {
                                let _prefix = '';

                                if( __key === 'start' ) {
                                    _prefix = '最早於';
                                }else if( __key === 'end' ) {
                                    _prefix = '最晚於';
                                }else if( __key === 'min' ) {
                                    _prefix = '最少為';
                                }else if( __key === 'max' ) {
                                    _prefix = '最多為';
                                }

                                $value.push(_prefix +' '+ value[__key]);
                            }
                        }
                        _value = $value.join(', ');
                    }

                    $result.push(_caption +': '+ _value);
                }

                let _result = $result.join(' ');

                return _result;
            }
        },
        watch: {
            table: {
                handler: function(){
                    this.initTable();
                }
            },
            pageSet: {
                handler: function(){
                    this.setPage(this.pageSet);
                }
            },
        },
        methods: {
            ...mapMutations([
                'reload',
                'pushPopUp',
                'clearPopUp',
            ]),
            validate: function() {
                let $_mdMajorTable = this.$refs.mdMajorTable;

                if(  $_mdMajorTable ) {
                    let $_validate = $_mdMajorTable.validate;

                    return $_validate().then(result => {
                        return result;
                    });
                }else {
                    return true;
                }
            },
            toggleCtrlDisplayToolBar: function(){
                let _barID = this.titleIDname +'__bar',
                    _displayBar = !this.ctrlDisplayToolBar;

                localStorage.setItem(_barID, _displayBar);

                this.$set(this, 'ctrlDisplayToolBar', _displayBar);
            },
            setTabValue: function(prop, value){
                let $value = this.ctrlSearchCondition[prop].value,
                    _index = $value.indexOf(value);

                if( _index < 0 ) { // -1 = 沒有
                    $value.push(value);
                }else {
                    $value.splice(_index, 1);
                }
            },
            doSearch: function(){
                this.saveCondition();
                this.searchCore();
            },
            reSearch: function(){
                this.removeCondition();
                this.searchCore();
            },
            saveCondition: function(){
                let _searchID = this.titleIDname +'__search',
                    $ctrlSearchCondition = this.ctrlSearchCondition,
                    _ctrlSearchCondition = JSON.stringify($ctrlSearchCondition);

                localStorage.setItem(_searchID, _ctrlSearchCondition);

                this.$set(this, 'realSearchCondition', this.$okaTool.copy($ctrlSearchCondition));
            },
            removeCondition: function(){
                let _searchID = this.titleIDname +'__search',
                    $initCondition = this.getInitSearchCondition(),
                    _initCondition = JSON.stringify($initCondition);

                localStorage.setItem(_searchID, _initCondition);

                this.$set(this, 'ctrlSearchCondition', this.$okaTool.copy($initCondition));
                this.$set(this, 'realSearchCondition', this.$okaTool.copy($initCondition));
            },
            searchConditionCompute: function(condition){
                let $title = this.title,
                    $clone = this.$okaTool.copy(condition);

                for( let _key in condition ) {
                    let $target = $title.find(item => {
                            return item.prop === _key;
                        });

                    let _remove = false;

                    if( $target && $target.visible === false ) {
                        _remove = true;
                    }else if( condition[_key].value === '' ) {
                        _remove = true;
                    }else if( typeof condition[_key].value === 'object' ) {
                        let _value = JSON.stringify(condition[_key].value);

                        if( _value === '[]' || _value === '{"start":"","end":""}' || _value === '{"min":"","max":""}' ) {
                            _remove = true;
                        }
                    }

                    if( _remove ) {
                        delete $clone[_key];
                    }
                }

                return $clone;
            },
            searchCore: function(){
                let $computedSearchCondition = this.computedSearchCondition,
                    $content = this.content;

                if( this.$okaTool.isEmptyObj($computedSearchCondition) ) {

                    $content.forEach(data => {
                        data.show = true;
                    });
                }else {

                    $content.forEach(data => {
                        let _show = true;

                        let $_convertType = (val) => {

                                if( val === undefined || val === null ) {
                                    return '';
                                }else if( typeof val === 'boolean' || typeof val === 'number' ) {
                                    return val.toString();
                                }else {
                                    return val;
                                }
                            }

                        for( let _key in $computedSearchCondition ){
                            let _this = this.$okaTool.htmlFilter(data[_key]),
                                _that = this.$okaTool.htmlFilter($computedSearchCondition[_key].value),
                                _type = $computedSearchCondition[_key].inputtype;

                            _this = $_convertType(_this);
                            _that = $_convertType(_that);

                            if( _type === 'month' || _type === 'date' || _type === 'datetime-local' || _type === 'time' ) { //select 必須完全符合
                                let _start = _that.start,
                                    _end = _that.end;

                                let _prefix = '';

                                if( _type === 'time' ) {
                                    _prefix = '1987-10-02T'; //加入某個日期比時間
                                }

                                let $this = new Date(_prefix + _this);

                                if( _start ) {
                                    let $start = new Date(_prefix + _start);

                                    if( $start > $this ) {
                                        _show = false;
                                    }
                                }

                                if( _end ) {
                                    let $end = new Date(_prefix + _end);

                                    if( $end < $this ) {
                                        _show = false;
                                    }
                                }

                            }else if( _type === 'number' ) {
                                let _min = _that.min,
                                    _max = _that.max;

                                _this = parseFloat(_this, 10) || 0;

                                if( _min ) {
                                    _min = parseFloat(_min, 10) || 0;

                                    if( _min > _this ) {
                                        _show = false;
                                    }
                                }

                                if( _max ) {
                                    _max = parseFloat(_max, 10) || 0;

                                    if( _max < _this ) {
                                        _show = false;
                                    }
                                }

                            }else if( _type === 'checkbox' || _type === 'combobox' || _type === 'tab' ) {

                                if( _that.length && _that.includes(_this) === false ) {
                                    _show = false;
                                }
                            }else if( _type === 'select' ) { //select 必須完全符合
                                _this = _this;
                                _that = _that;

                                if( _this !== _that ) {
                                    _show = false;
                                }
                            }else {

                                if ( typeof _this === 'string' && typeof _that === 'string' ) {
                                    _this = _this.toLowerCase();
                                    _that = _that.toLowerCase();
                                }

                                if( !_this.includes(_that) ) {
                                    _show = false;
                                }
                            }
                        }

                        data.show = _show;
                    });
                }

                this.$emit('sendEvent', 'updateSearch', $computedSearchCondition);

                if( this.searchInit ) {
                    this.setPage(1, this.pageFunc);
                }

                this.$set(this, 'searchInit', true);
            },
            getInitSearchCondition: function(){
                let $result = {},
                    $title = this.title;

                $title.forEach(title => {

                    if( title.searchable ) {
                        let _prop = title.prop,
                            _caption = title.caption,
                            _inputtype = title.inputtype,
                            _value = '';

                        if( _inputtype === 'date' || _inputtype === 'month' || _inputtype === 'datetime-local' || _inputtype === 'time' ){

                            _value = {
                                start: '',
                                end: ''
                            }
                        }else if( _inputtype === 'number' ){

                            _value = {
                                min: '',
                                max: ''
                            }
                        }else if( _inputtype === 'combobox' || _inputtype === 'checkbox' || _inputtype === 'tab' ) {
                            _value = [];
                        }

                        $result[_prop] = {
                            caption: _caption,
                            inputtype: _inputtype,
                            value: _value
                        }
                    }
                });

                return $result;
            },
            setTableTitle: function(){

                this.pushPopUp({
                    type: 'setTableTitle',
                    content: {
                        node: this.title,
                        update: (data) => {
                            this.updateTitle(data, 'update');
                        },
                        revert: this.resetTitle
                    }
                });
            },
            updateTitle: function(node, mode){
                let $table = this.table,
                    $title = $table.title || [],
                    $clone = this.$okaTool.copy($title);

                if( mode === 'update' ) {
                    localStorage.setItem(this.titleIDname, JSON.stringify(node));
                }

                node.forEach(item => {
                    let _prop = item.prop,
                        _visible = item.visible,
                        _sortnum = item.sortnum;

                    let $target = $clone.find(clone => {
                            return clone.prop === _prop;
                        });

                    if( $target ) {
                        $target.visible = _visible;
                        $target.sortnum = _sortnum;
                    }
                });

                this.$set(this.table, 'title', $clone);
            },
            resetTitle: function(){
                localStorage.removeItem(this.titleIDname);

                this.reload();
            },
            mackFile: function(useApp){
                let $title = this.titleComputed,
                    $content = this.showFilter;

                let $dataArray = [''];

                $title.forEach(title => {
                    if( title.prop !== 'func') {
                        let _title = title.caption || '';

                        if( typeof _title !== 'string' ) {
                            _title = _title.toString();
                        }

                        let _result = _title.replace(/<[^>]*>?/gm, '').replace(/\,/g, '_').replace(/\#/g, '');

                        $dataArray[0] += (_result +',');
                    }
                });

                $content.forEach(content => {
                    let _results = '';

                    $title.forEach(title => {

                        if( title.prop !== 'func') {
                            let _result = content[title.prop];

                            if( typeof _result === 'string' || ( typeof _result === 'number' && ( _result.toString().includes('e') || _result.toString().includes('E')))) {
                                _result = _result.toString().replace(/<[^>]*>?/gm, '').replace(/\,/g, '-').replace(/\#/g, '');

                                if( useApp === 'excel' ) {

                                    if( _result.includes('"') ) {
                                        _result = _result.replaceAll('"', '""');
                                    }

                                    _result = '="'+ _result +'"';
                                }
                            }else if( _result === undefined || _result === null ) {
                                _result = '';
                            }

                            _results += (_result +',');
                        }
                    });

                    $dataArray.push(_results);
                });

                let _dataString = $dataArray.join('\n');

                return 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(_dataString);
            },
            downloadTable: function(name) {
                let $_downloadCore = (useApp) => {
                        let $file = this.mackFile(useApp),
                            _name = name || this.downloadName ||  'table';

                        let _date = this.$okaTool.dateToStringFormat().ymd;

                        this.$siteTool.downloadCore($file, _name +'_'+ _date + '.csv');
                    },
                    $_download = () => {
                        $_downloadCore();
                        this.clearPopUp();
                    }


                let $normalCSV = {
                        text: '標準 CSV',
                        themes: 'info',
                        func: 'download'
                    }

                this.pushPopUp({
                    type: 'confirm',
                    content: {
                        caption: '選擇匯出格式',
                        html: '若您選擇 <strong>相容 Excel 的 CSV</strong>，系統會強制保存字元的完整性以符合 Excel 的使用情境。<br>若您將其他應用程式開啟匯出檔案，請選擇 <strong>標準 CSV</strong>。',
                        actionName: '相容 Excel 的 CSV',
                        actionTheme: 'info',
                        action: () => {
                            $_downloadCore('excel');
                            this.clearPopUp();
                        },
                        moreBtns: [
                            $normalCSV
                        ],
                        download: $_download
                    }
                })
            },
            sortByKey: function(key){
                let $titles = this.title,
                    $contents = this.content;

                let _sort = null;

                let $_isNull = (opt) => {
                        return opt === null || opt === undefined;
                    }

                let $_core = (a, b) => {
                        let _a = a[key],
                            _b = b[key];

                        if( $_isNull(_a) && $_isNull(_b) ) {
                            return false;
                        }else if( $_isNull(_a) ){
                            return false;
                        }else if( $_isNull(_b) ){
                            return true;
                        }else{

                            if( typeof _a === 'string' && typeof _b === 'string' ) {

                                if( this.$okaTool.isNumber(_a) && this.$okaTool.isNumber(_b) ) {
                                    _a = parseFloat(_a.replace(/\,/g, ''));
                                    _b = parseFloat(_b.replace(/\,/g, ''));
                                }else if( this.$okaTool.isDate(_a) && this.$okaTool.isDate(_b) ) {
                                    _a = new Date(_a);
                                    _b = new Date(_b);
                                }
                            }else if( Array.isArray(_a) && Array.isArray(_b) ) {
                                _a = _a.length + JSON.stringify(_a);
                                _b = _b.length + JSON.stringify(_b);
                            }else if( typeof _a === 'object' && typeof _b === 'object' ) {
                                _a = JSON.stringify(_a);
                                _b = JSON.stringify(_b);
                            }else {
                                _a = this.$okaTool.convertToString(_a);
                                _b = this.$okaTool.convertToString(_b);
                            }

                            return _a > _b;
                        }
                    }

                $titles.forEach($title => {

                    if( $title.prop === key ){ //如果是要用這個 title 來排序

                        if( $title.sortable ){ //並且這個 title 是可排序的

                            if( $title.sort === 'desc' ){
                                $title.sort = 'asc';
                                _sort = 'up';
                            }else { //asc 或是空字串等其他不符預期的值
                                $title.sort = 'desc';
                                _sort = 'down';
                            }
                        }else {
                            console.log('此欄位不可排序');
                            return false;
                        }
                    }else {
                        $title.sort = '';
                    }
                });

                if( _sort === 'up' ){ //如果有找到排序標的
                    $contents.sort((a, b) => {
                        let _result = $_core(a, b);

                        return _result? -1: 1
                    });
                }else { //down
                    $contents.sort((a, b) => {
                        let _result = $_core(a, b);

                        return _result? 1: -1
                    });
                }

                // if( this.havePageination ) { //如果要 show 頁籤
                //     this.changeByLength(this.show); //重新寫 page
                // }
            },
            changeByLength: function(length){ //改一次顯示的數量
                let _changeID = this.titleIDname +'__length',
                    _length = parseInt(length, 10);

                localStorage.setItem(_changeID, _length);
                
                this.setPage(1, this.pageFunc);
                
                this.show = _length;
            },
            setPage: function(page, callback){
                let _page = parseInt(page);

                if( callback && typeof callback === 'function' ) {
                    callback(_page);
                }else {
                    this.$set(this, 'page', _page);
                }
            },
            changeByPage: function(page){ //改頁面
                this.setPage(page, this.pageFunc);
            }, //======== 拖曳行為 =========
            startDropStatus: function(obj){
                this.moveNode = obj.obj;
                this.addClass(obj.node);
            },
            endDropStatus: function(obj){
                this.moveNode = null;
                this.away = '';
                this.catchNodeSn = '';
                this.removeClass(obj.node);
            },
            changeData: function(obj){
                let $obj = obj.obj,
                    _away = obj.away,
                    $node = obj.node;

                this.removeClass($node);
                this.changeIndex(this.moveNode, $obj, _away, $node);
            },
            movingStart: function(obj){ //開始滑入
                let $obj = obj.obj,
                    _away = obj.away,
                    $node = obj.node;

                this.catchNodeSn = $obj.sn;
                this.away = _away;
                this.addClass($node);
            },
            movingEnd: function(target){ //結束滑入
                this.catchNodeSn = '';
                this.away = '';
                this.removeClass(target);
            },
            addClass: function(target){ //滑入物件加 class 改變顏色
                target.classList.add('is-drop');
            },
            removeClass: function(target){ //滑入物件刪除 class 改變顏色
                target.classList.remove('is-drop');
            },
            changeIndex: function(moveNode, catchNode, away, node){
                let $table = this.table,
                    $title = $table.title || [],
                    $content = $table.content || [];

                if( moveNode !== catchNode ) {

                    let _moveNodeIndex = $content.indexOf(moveNode);

                    $content.splice(_moveNodeIndex, 1); //先移除自己

                    let _catchNodeIndex = $content.indexOf(catchNode);

                    if( away === 'top' ){
                        $content.splice(_catchNodeIndex, 0, moveNode);
                    }else if( away === 'bottom' ) {
                        $content.splice(_catchNodeIndex + 1, 0, moveNode);
                    }

                    this.$emit('sendEvent', 'tableDrop', moveNode);
                }

                this.endDropStatus({ //不知道 why 第一次拖曳總是不能自己觸發 endDropStatus
                    obj: catchNode,
                    node: node
                });

                $title.forEach($title => {
                    $title.sort = '';
                });
            },
            sendFuncEvent: function(func, obj){
                this.$emit('sendEvent', func, obj);
            },
            updateSortAndVisitable: function(){
                let _setTitle = this.setTitle;

                if( _setTitle ) {
                    let _titleData = localStorage.getItem(this.titleIDname);

                    if( _titleData ) {
                        this.updateTitle(JSON.parse(_titleData), 'revert');
                    }
                }

                let $table = this.table,
                    $title = $table.title || [];

                let $target = $title.find(item => {
                        return item.sort === 'asc' || item.sort === 'desc';
                    });

                if( $target ) {
                    this.sortByKey($target.prop);
                }
            },
            updateSearchHistory: function(){
                let _searchID = this.titleIDname +'__search',
                    _StorageSearchCondition = localStorage.getItem(_searchID) || '{}',
                    $StorageSearchCondition = JSON.parse(_StorageSearchCondition),
                    $searchCondition = this.getInitSearchCondition();

                let $table = this.table,
                    $content = $table.content || [];

                for( let _key in $searchCondition ) {
                    let _write = false;

                    if( $StorageSearchCondition[_key] ) {
                        let $StorageSearchConditionItem = $StorageSearchCondition[_key],
                            $searchConditionItem = $searchCondition[_key];

                        if( $StorageSearchConditionItem.inputtype === $searchConditionItem.inputtype ) {
                            let _inputType = $StorageSearchConditionItem.inputtype;

                            if( _inputType === 'checkbox' || _inputType === 'combobox' || _inputType === 'tab' ) {
                                let $value = $StorageSearchConditionItem.value, //array
                                    $options = [],
                                    $result = [];

                                $content.forEach(content => {
                                    let _value = content[_key];

                                    if( _value && !$options.includes(_value) ) {
                                        $options.push(_value);
                                    }
                                });

                                $value.forEach(value => {

                                    if( $options.includes(value) ) {
                                        $result.push(value);
                                    }
                                });

                                $searchConditionItem.value = $result;

                            }else if( _inputType === 'select' ){

                                let $target = $content.find(content => {
                                        return content[_key] === $StorageSearchConditionItem.value;
                                    });

                                if( $target ) {
                                    $searchConditionItem.value = $StorageSearchConditionItem.value;
                                }
                            }else {
                                $searchConditionItem.value = $StorageSearchConditionItem.value;
                            }
                        }
                    }
                }

                this.$set(this, 'realSearchCondition', this.$okaTool.copy($searchCondition));
                this.$set(this, 'ctrlSearchCondition', this.$okaTool.copy($searchCondition));
                this.searchCore();
            },
            updateBarDisplay:function(){
                let _barID = this.titleIDname +'__bar',
                    _displayBar = localStorage.getItem(_barID);

                if( _displayBar === null ) {
                    _displayBar = this.displayToolBar;
                }else {
                    _displayBar = JSON.parse(_displayBar);
                }

                this.$set(this, 'ctrlDisplayToolBar', _displayBar);
            },
            updateLength:function(){
                let _changeID = this.titleIDname +'__length',
                    _length = localStorage.getItem(_changeID);

                if( _length === null ) {
                    _length = this.setLength;
                }else {
                    _length = parseInt(_length, 10);
                }

                this.$set(this, 'show', _length);
            },
            initData: function(){
                let $content = this.content;

                $content.forEach(data => {
                    data.show = true;

                    if( data.sn === undefined ) {
                        data.sn = this.$okaTool.getUUID();
                    }
                });
            },
            initTable: function(){

                if( this.rememberHistory ) {
                    this.initData();
                    this.updateLength();
                    this.updateBarDisplay();
                    this.updateSortAndVisitable();
                    this.updateSearchHistory();
                }
            }
        },
        // created: function(){
        //     this.initTable();
        // }
    }
</script>

<style scoped lang="scss">

    .g.table {
        
    }
</style>
